<template>
  <div v-if="$apollo.loading || loading">
    <spinner />
  </div>
  <main v-else class="content">
    <section class="main-section">
      <article class="main-section__content">
        <div
          :style="{
            backgroundImage: 'url(' + image + ')',
            backgroundColor: image ? 'transparent' : '#ffffff25',
          }"
          :class="type === 'ORGANIZATION' ? 'logo-image-container' : 'event-image-container'"
        />
        <div class="accept-invite-title">
          {{ title }}
        </div>
        <div>
          <main-button
            class="accept-button"
            depressed
            :text="type === 'ORGANIZATION' ? 'otvori organizaciju' : 'otvori event'"
            @click="accept()"
          />
        </div>
      </article>
    </section>
  </main>
</template>

<script>
import { GET_LOGGED_USER } from '../../graphql/user.graphql'
import { ACCEPT_INVITE } from '../../graphql/invite.graphql'

export default {
  props: {
    token: {
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      image: null,
      title: null,
      type: null,
      organizationSlug: null,
      eventId: null,
      user: null,
    }
  },
  methods: {
    accept() {
      if (this.type === 'ORGANIZATION') {
        this.goTo(this.routes.main.organizationSidebar, {
          organizationSlug: this.organizationSlug,
        })
      } else {
        this.goTo(this.routes.main.organizerSidebar, {
          organizationSlug: this.organizationSlug,
          eventId: this.eventId,
        })
      }
    },
  },
  apollo: {
    me: {
      query: GET_LOGGED_USER,
      async result({ data, loading }) {
        if (!loading && data) {
          if (!data.me) {
            const redirect = window.location.href
            window.location.href = `${
              process.env.VUE_APP_FRONTEND_URL
            }/login?redirect_url=${encodeURIComponent(redirect)}`
          } else {
            this.user = data.me
            const { errors, data: newData } = await this.$apollo.mutate({
              mutation: ACCEPT_INVITE,
              variables: { token: this.token },
            })

            if (errors) {
              this.goTo({ path: '/' })
            } else {
              this.image = newData.acceptInvite.image
              this.title =
                newData.acceptInvite.type === 'ORGANIZATION'
                  ? `Uspješno ste postali dio ${newData.acceptInvite.name} organizacije`
                  : `Uspješno ste postali dio eventa: ${newData.acceptInvite.name}`
              this.type = newData.acceptInvite.type
              this.organizationSlug = newData.acceptInvite.organizationSlug
              this.eventId = newData.acceptInvite.eventId
              this.loading = false
            }
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.logo-image-container {
  height: 11.375rem;
  width: 11.375rem;
  background-size: cover;
  border-radius: 6rem !important;
}
.event-image-container {
  height: 11.375rem;
  width: 20rem;
  background-size: cover;
  object-fit: cover;
  border-radius: 4px;
}
.main-section__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.accept-invite-title {
  font-family: Raleway;
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  color: #333333;
  margin-top: 3.5rem;
  max-width: 42rem;
}
.accept-button {
  margin-top: 2rem;
}
.content {
  display: grid;
  grid-auto-rows: auto;
  gap: 13.125rem;
  margin-bottom: 13.125rem;
}
.main-section {
  max-width: 1216px;
  padding: 0 2.625rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.625rem;
  align-items: center;
}
.main-section__content {
  margin: 2.625rem 0;
}

@media screen and (max-width: 800px) {
  .accept-invite-title {
    font-size: 48px;
  }
}

@media screen and (max-width: 480px) {
  .accept-invite-title {
    font-size: 32px;
  }
  .event-image-container {
    width: 16rem;
  }
}
</style>
